//ASSETS
import otherArticles1 from "assets/img/otherArticles1.jpg";
import otherArticles2 from "assets/img/otherArticles2.jpg";

export const content = {
  text: `**1.** Instalează cel puțin un detector de fum în mod ideal, unul la fiecare etaj și unul în afara fiecărei zone de dormit). Testează-le și înlocuiește-le bateriile când auzi sunetul de baterie descărcată. <br>
  **2.** Învăță-i pe copii cum sună alarmele de fum și ce să facă atunci când aud una.  
  **3.** Asigură-te că toți membrii familiei cunosc două modalități de a ieși din fiecare cameră a casei.  
  **4.** Exersează evacuarea din casă cel puțin de două ori pe an, inclusiv exercițiul de așezare la pământ pentru a evita fumul.  
  **5.** Asigură-te că toată lumea știe unde este punctul de întâlnire sigur.  
  **6.** Asigură-te că toată lumea știe cum să sune la 112.  
  **7.** Învăță-i pe membrii familiei să se oprească, să se așeze la pământ și să se rostogolească dacă hainele lor iau foc.
  **1.** Instalează cel puțin un detector de fum în mod ideal, unul la fiecare etaj și unul în afara fiecărei zone de dormit). Testează-le și înlocuiește-le bateriile când auzi sunetul de baterie descărcată. <br>
  **2.** Învăță-i pe copii cum sună alarmele de fum și ce să facă atunci când aud una.  
  **3.** Asigură-te că toți membrii familiei cunosc două modalități de a ieși din fiecare cameră a casei.  
  **4.** Exersează evacuarea din casă cel puțin de două ori pe an, inclusiv exercițiul de așezare la pământ pentru a evita fumul.  
  **5.** Asigură-te că toată lumea știe unde este punctul de întâlnire sigur.  
  **6.** Asigură-te că toată lumea știe cum să sune la 112.  
  **7.** Învăță-i pe membrii familiei să se oprească, să se așeze la pământ și să se rostogolească dacă hainele lor iau foc.
  `,
  otherChapters: [
    {
      id: 0,
      img: otherArticles1,
      title:
        "Lorem ipsum dolor sit amet, consectetur adipiscing eli @@@@@ @@@@@@ @@@@ @@@@@@ @@ ",
    },
    {
      id: 1,
      img: otherArticles2,
      title:
        " Lorem ipsum dolor sit amet, consectetur adipiscing elit Lorem ipsum dolor sit amet, consectetur adipiscing elit Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    },
    {
      id: 2,
      img: otherArticles2,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    },
  ],
};

export const carouselCards = [
  {
    id: 1,

    image: otherArticles1,
  },
  {
    id: 2,

    image: otherArticles1,
  },
  {
    id: 3,

    image: otherArticles1,
  },
  {
    id: 4,
    image: otherArticles2,
  },
  {
    id: 5,

    image: otherArticles1,
  },
  {
    id: 6,

    image: otherArticles1,
  },
  {
    id: 7,

    image: otherArticles1,
  },
  {
    id: 8,

    image: otherArticles1,
  },
];
